import { PKG_PRODUCTS_SEED_DATA } from './pkgProductsSeed';

export interface CreamVarietyStandard {
    productName: string;
    productCode: string;
    lineName: string;
    productCategory: string;
    standardCreamPercentage: number;
    standardMin: number;
    standardMax: number;
    description?: string;
}

/**
 * Returns standard cream percentage, min, and max for any variety name.
 * Uses Mrs Bector's / Cremica quality QA specifications.
 */
export function getCreamStandardForVariety(title: string): {
    standardCreamPercentage: number;
    standardMin: number;
    standardMax: number;
    ruleDescription: string;
} {
    const t = (title || '').toUpperCase();

    // 1. Bourbon Varieties (24.00% standard)
    if (t.includes('BOURBON')) {
        return {
            standardCreamPercentage: 24.00,
            standardMin: 22.50,
            standardMax: 25.50,
            ruleDescription: 'Bourbon Recipe QA Standard (24.00% ± 1.50%)'
        };
    }

    // 2. Melto Varieties (27.50% standard)
    if (t.includes('MELTO')) {
        return {
            standardCreamPercentage: 27.50,
            standardMin: 25.50,
            standardMax: 29.50,
            ruleDescription: 'Melto Creme QA Standard (27.50% ± 2.00%)'
        };
    }

    // 3. Magicreme / Magic Cream Varieties (28.00% standard)
    if (t.includes('MAGICREME') || t.includes('MAGIC CREAM')) {
        return {
            standardCreamPercentage: 28.00,
            standardMin: 26.00,
            standardMax: 30.00,
            ruleDescription: 'Magic Cream QA Standard (28.00% ± 2.00%)'
        };
    }

    // 4. Double Cream / Duo / Tray / Aunt Baker / HEB (29.00% standard)
    if (t.includes('DOUBLE') || t.includes('TRAY') || t.includes('DUO') || t.includes('AUNT BAKER') || t.includes('BISKWI')) {
        return {
            standardCreamPercentage: 29.00,
            standardMin: 27.00,
            standardMax: 31.00,
            ruleDescription: 'Heavy Sandwich / Double Cream QA Standard (29.00% ± 2.00%)'
        };
    }

    // 5. Spheres / Chelsea / Trio / UBrand / Jumbo / Adoro (28.00% standard)
    if (t.includes('SPHERES') || t.includes('CHELSEA') || t.includes('TRIO') || t.includes('UBRAND') || t.includes('JUMBO') || t.includes('ADORO')) {
        return {
            standardCreamPercentage: 28.00,
            standardMin: 26.00,
            standardMax: 30.00,
            ruleDescription: 'Export Sandwich Cookies Standard (28.00% ± 2.00%)'
        };
    }

    // 6. General Sandwich Cream Cookies (Default Cremica QA Specification)
    return {
        standardCreamPercentage: 28.00,
        standardMin: 26.00,
        standardMax: 30.00,
        ruleDescription: 'Standard Cream QA Specification (28.00% ± 2.00%)'
    };
}

/**
 * Filtered master list of all Cream / Sandwich Cream varieties across Lines 5, 6, 7 and all lines.
 */
export const CREAM_VARIETIES_CATALOG: CreamVarietyStandard[] = (PKG_PRODUCTS_SEED_DATA || [])
    .filter(p => {
        const cat = (p.productCategory || '').toLowerCase();
        const title = (p.title || '').toLowerCase();
        return cat.includes('cream') || cat.includes('sandwich') ||
            title.includes('bourbon') || title.includes('cream') || title.includes('creme') ||
            title.includes('melto') || title.includes('spheres') || title.includes('chelsea') ||
            title.includes('trio') || title.includes('magic');
    })
    .map(p => {
        const std = getCreamStandardForVariety(p.title);
        return {
            productName: p.title,
            productCode: p.productCode,
            lineName: p.lineName,
            productCategory: p.productCategory,
            standardCreamPercentage: std.standardCreamPercentage,
            standardMin: std.standardMin,
            standardMax: std.standardMax,
            description: std.ruleDescription
        };
    });
